import React from 'react';

import Page from '../../components/ui/Page';
import Form from '../../components/application/ForgotPassword';
import Onboarding from '../../components/application/Authentication/Onboarding';

import * as Styles from './ForgotPasswordStyles';

const ForgotPasswordForm: React.FC = () => {
  return (
    <Page>
      <Styles.Container>
        <Styles.FormContainer>
          <Form />
        </Styles.FormContainer>
        <Onboarding />
      </Styles.Container>
    </Page>
  );
};

export default ForgotPasswordForm;
